/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Filter_SecondaryInputs */

const en_us2_plan_build_filter_secondary = /** @type {(inputs: Plan_Build_Filter_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include where it is secondary`)
};

const pt_br2_plan_build_filter_secondary = /** @type {(inputs: Plan_Build_Filter_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir onde é secundário`)
};

const es_419_plan_build_filter_secondary = /** @type {(inputs: Plan_Build_Filter_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir donde es secundario`)
};

const pt_pt2_plan_build_filter_secondary = /** @type {(inputs: Plan_Build_Filter_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir onde é secundário`)
};

const fr_fr2_plan_build_filter_secondary = /** @type {(inputs: Plan_Build_Filter_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure en secondaire`)
};

const de_de2_plan_build_filter_secondary = /** @type {(inputs: Plan_Build_Filter_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch als Nebenmuskel`)
};

const it_it2_plan_build_filter_secondary = /** @type {(inputs: Plan_Build_Filter_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi dove è secondario`)
};

/**
* | output |
* | --- |
* | "Include where it is secondary" |
*
* @param {Plan_Build_Filter_SecondaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_filter_secondary = /** @type {((inputs?: Plan_Build_Filter_SecondaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Filter_SecondaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_filter_secondary(inputs)
	if (locale === "es-419") return es_419_plan_build_filter_secondary(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_filter_secondary(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_filter_secondary(inputs)
	if (locale === "de-DE") return de_de2_plan_build_filter_secondary(inputs)
	if (locale === "it-IT") return it_it2_plan_build_filter_secondary(inputs)
	return en_us2_plan_build_filter_secondary(inputs)
});
export { plan_build_filter_secondary as "plan-build.filter_secondary" }